export const saveCookieObj = (name,data) => {
  document.cookie = `${name}=${JSON.stringify(data)}`
}

export const readCookieObj = (name) => {
  const cookies = document.cookie.split(';')
  let data: any = false;
  cookies.forEach((cookie) => {
    if(cookie.startsWith(name)){
       data = cookie.replace(`${name}=`,"");
       data = JSON.parse(data);
    }
  })
  return data;
}